var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActivitySupervision(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 4.25H6C3.93 4.25 2.25 5.93 2.25 8V16C2.25 18.07 3.93 19.75 6 19.75H18C20.07 19.75 21.75 18.07 21.75 16V8C21.75 5.93 20.07 4.25 18 4.25ZM6 5.75H18C19.24 5.75 20.25 6.76 20.25 8V11.25H16.4L14.62 8.58C14.34 8.16 13.65 8.16 13.37 8.58L9.99 13.64L8.61 11.58C8.47 11.37 8.24 11.25 7.99 11.25H3.75V8C3.75 6.76 4.76 5.75 6 5.75ZM18 18.25H6C4.76 18.25 3.75 17.24 3.75 16V12.75H7.6L9.38 15.42C9.52 15.63 9.75 15.75 10 15.75C10.25 15.75 10.48 15.62 10.62 15.42L14 10.36L15.38 12.42C15.52 12.63 15.75 12.75 16 12.75H20.25V16C20.25 17.24 19.24 18.25 18 18.25Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivitySupervision);
export default __webpack_public_path__ + "static/media/activity-supervision.af2439885698fed0a4dfdb6e583c727c.svg";
export { ForwardRef as ReactComponent };